<template>
<section class="contact">
  <section class="title">让沟通更高效</section>
  <section class="contact-now">
    <input :value="mobile" type="tel" placeholder="请输入您的手机号码" class="contact-now-val" id="contactId">
    <div @click="GoInput()" class="contact-now-btn">马上联系</div>
  </section>
</section>
</template>

<script>
export default {
  name: '',
  data(){
    return {
      mobile: ''
    }
  },
  props: {
    
  },
  mounted () {
    // this.$refs.contactRef.focus();
  },
  methods: {
    GoInput() {
        // if (this.mobile != '') {
        //     $.ajax({
        //         url: "http://www.xnuoo.com/tools/submit.ashx",
        //         type: "Post",
        //         data: {tel: this.mobile},
        //         success: function (msg) {
        //             if (msg == "success") {
        //                 layer.msg("提交成功", { time: 2000 }, function () {
        //                     window.location.reload();
        //                 });
        //             } else {
        //                 alert(msg);
        //             }
        //         }
        //     })
        // }
    }
  }
}
</script>

<style scoped lang="less">
.contact {
    background: url(../assets/img/contact-bg.png) no-repeat center center;
    background-size: cover;
    padding-bottom: 64px;
    height: 300px;
    text-align: center;
    .title {
        padding-top: 5%;
        font-size: 35px;
        color: #fff;
        letter-spacing: 4.5px;
        text-align: center;
    }
    .contact-now {
        position: relative;
        // display: -webkit-box;
        // display: -ms-flexbox;
        // display: flex;
        display: inline-block;
        color: #fff;
        text-align: center;
        -webkit-box-pack: center;
        -ms-flex-pack: center;
        justify-content: center;
        margin-top: 30px;
        font-size: 0;
        input {
            vertical-align: top;
            display: inline-block;
            width: 580px;
            height: 46px;
            line-height: 46px;
            -webkit-box-sizing: border-box;
            box-sizing: border-box;
            border-radius: 44px;
            // border-bottom-left-radius: 44px;
            padding: 0 30px;
            font-size: 16px;
            margin-right: 16px;
        }
        .contact-now-btn {
          position: absolute;
          right: 0;
          vertical-align: top;
          display: inline-block;
          background: #08f;
          width: 140px;
          height: 46px;
          line-height: 46px;
          cursor: pointer;
          font-size: 16px;
          border-top-right-radius: 44px;
          border-bottom-right-radius: 44px;
      }
    }
}
</style>
